import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import Technicians from "./pages/Technicians";
import Invoices from "./pages/Invoices";
import Quotes from "./pages/Quotes";
import WorkTracking from "./pages/WorkTracking";
import Appointments from "./pages/Appointments";
import Reports from "./pages/Reports";
import Integrations from "./pages/Integrations";
import Settings from "./pages/Settings";
import Activity from "./pages/Activity";
import Expenses from "./pages/Expenses";
import Mileage from "./pages/Mileage";
import Messages from "./pages/Messages";
import PayInvoice from "./pages/PayInvoice";
import BookAppointment from "./pages/BookAppointment";
import ManageAppointment from "./pages/ManageAppointment";
import AutopayManage from "./pages/AutopayManage";
import ReviewQuote from "./pages/ReviewQuote";
import Layout from "./components/Layout";
import { Toaster } from "./components/ui/sonner";
import "./utils/axios"; // Initialize axios interceptors

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/pay/:token" element={<PayInvoice />} />
        <Route path="/autopay/:token" element={<AutopayManage />} />
        <Route path="/quote/:token" element={<ReviewQuote />} />
        <Route path="/book" element={<BookAppointment />} />
        <Route path="/appointment/:token" element={<ManageAppointment />} />
        <Route path="*" element={user ? (
        <Layout user={user} onLogout={handleLogout}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/technicians" element={<Technicians />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/quotes" element={<Quotes />} />
            <Route path="/work" element={<WorkTracking />} />
            <Route path="/appointments" element={<Appointments />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/activity" element={<Activity />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/mileage" element={<Mileage />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Layout>
      ) : (
        <Routes>
          <Route path="*" element={<Login onLogin={handleLogin} />} />
        </Routes>
      )} />
      </Routes>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
